import { render, staticRenderFns } from "./DocumentInput.vue?vue&type=template&id=35fc76cc"
import script from "./DocumentInput.vue?vue&type=script&lang=js"
export * from "./DocumentInput.vue?vue&type=script&lang=js"
import style0 from "./DocumentInput.vue?vue&type=style&index=0&id=35fc76cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports